import { render } from "./Register.vue?vue&type=template&id=7339dbea"
import script from "./Register.vue?vue&type=script&lang=ts"
export * from "./Register.vue?vue&type=script&lang=ts"
script.render = render

export default script